const SentryTestPage = () => {
  console.log("test", undefinedFunction());
  return <div>SentryTestPage</div>;
};

export default SentryTestPage;
